import styled from 'styled-components';

export const Dot = styled.button`
  background: #fff;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  height: 66px;
  position: absolute;
  width: 66px;

  @media (max-width: 970px) {
    height: 48px;
    width: 48px;
  }
`;

export const DotInner = styled.span`
  background: rgba(18, 119, 198, 0.4);
  border: 3px solid #56b5ff;
  border-radius: 25px;
  cursor: pointer;
  display: block;
  height: 52px;
  left: 7px;
  overflow: hidden;
  position: absolute;
  text-indent: -100em;
  top: 7px;
  transition: all 300ms ease-out;
  width: 52px;

  @media (max-width: 970px) {
    height: 38px;
    left: 5px;
    width: 38px;
    top: 5px;
  }

  :hover {
    background: rgba(18, 119, 198, 0.7);
  }

  &.is-selected {
    background: rgba(18, 119, 198, 1);
  }
`;
